import React from 'react';
import { Link } from 'react-router-dom';

interface LegalLinksProps {
  className?: string;
}

const LegalLinks: React.FC<LegalLinksProps> = ({
  className = '',
}) => (
  <nav className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs ${className}`} aria-label="Legal">
    <Link to="/terms" className="underline-offset-4 hover:underline">Terms of Service</Link>
    <Link to="/privacy" className="underline-offset-4 hover:underline">Privacy Policy</Link>
  </nav>
);

export default LegalLinks;
